/**
 * Removes all HTML tags from a string.
 * @param html - The HTML string to be stripped of tags
 * @returns The input string with all HTML tags removed
 * @example
 * ```typescript
 * stripHtmlTags("<p>Hello <b>World</b></p>") // returns "Hello World"
 * ```
 */
export const stripHtmlTags = (html: string) => html.replace(/<\/?[^>]+(>|$)/g, '');
